import { axios } from "@/utils";

export const MonitorService = async () => {
  return await axios.get(`/monitrees-monitor-bff/monitor-service`);
};

export const MonitorOnboardingStep1Service = async (params: any) => {
  return await axios.post(`/monitrees-monitor-bff/onboarding/user-info`, {
    ...params,
  });
};

export const MonitorOnboardingStep2Service = async (params: any) => {
  return await axios.post(`/monitrees-monitor-bff/monitor`, {
    ...params,
  });
};

export const MonitorListService = async (pagination: any) => {
  return await axios.get(
    `/monitrees-monitor-bff/monitor?page=${pagination.page}&pageSize=${pagination.pageSize}`
  );
};

export const MonitorDetailService = async (params: any) => {
  return await axios.get(
    `/monitrees-monitor-bff/monitor-info?monitorId=${params.monitorId}`
  );
};

export const MonitorProductService = async (params: any) => {
  return await axios.get(
    `/monitrees-monitor-bff/monitor/shopify-products?monitorId=${
      params.monitorId
    }&limit=10&cursor=${params.cursor || ""}`
  );
};

export const MonitorDeleteService = async (id: any) => {
  return await axios.delete(`/monitrees-monitor-bff/monitor?monitor_ids=${id}`);
};

export const MonitorPutService = async (params: any) => {
  return await axios.put(`/monitrees-monitor-bff/monitor`, {
    ...params,
  });
};

export const MonitorPauseService = async (params: any) => {
  return await axios.post(`/monitrees-monitor-bff/monitor-pause`, {
    ...params,
  });
};

export const MonitorStartService = async (params: any) => {
  return await axios.post(`/monitrees-monitor-bff/monitor-start`, {
    ...params,
  });
};

export const MonitorReAuthorizeService = async (params: any) => {
  return await axios.get(
    `/monitrees-monitor-bff/monitor/ouathuri?monitor_id=${params.monitor_id}`
  );
};

export const MonitorAdsAccountService = async (id: string) => {
  return await axios.get(
    `/monitrees-monitor-bff/monitor/google-customers?monitor_id=${id}`
  );
};

export const MonitorAdsListService = async (ids: string, id: string) => {
  return await axios.get(
    `/monitrees-monitor-bff/monitor/google-customerads?resource_name=${ids}&monitor_id=${id}`
  );
};

export const MonitorFacebookAccountService = async (id: string) => {
  return await axios.get(
    `/monitrees-monitor-bff/monitor/facebook/account?monitor_id=${id}`
  );
};

export const MonitorFacebookListService = async (
  account_id: string,
  id: string
) => {
  return await axios.get(
    `/monitrees-monitor-bff/monitor/facebook/adsets?account_id=${account_id}&monitor_id=${id}`
  );
};

export const MonitorSendCodeService = async (params: any) => {
  return await axios.post(`/monitrees-monitor-bff/monitor/send-code`, params);
};

export const MonitorCheckCodeService = async (params: any) => {
  return await axios.post(`/monitrees-monitor-bff/monitor/verify-code`, params);
};
